export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-cell/index.js